import Info4Content from '../components/info/Info4PageContent';

const Info4Page = () => {
  return <Info4Content />;
};

export default Info4Page;